import { X } from "lucide-react";

import { cn } from "@/lib/utils";
import { ColocaIconButton, type IconButtonProps } from "@/shared/components/buttons/ColocaIconButton";

export type CloseButtonProps = Omit<IconButtonProps, "loading" | "variant">;

/**
 * Use to dismiss overlays: modals, drawers, toasts, banners, and inline alerts. Place it in the top-right
 * corner of the dismissible surface.
 *
 * The `X` icon is the default and sufficient for most cases — override `icon` only when a different symbol is
 * clearer in context (e.g. `<ChevronDown>` to collapse an inline panel rather than close it entirely).
 */
export function ColocaCloseButton({ icon: Icon = X, className, ...props }: CloseButtonProps) {
  return (
    <ColocaIconButton
      aria-label="Dismiss"
      icon={Icon}
      className={cn(className, "border-none bg-transparent")}
      {...props}
    />
  );
}
